// frontend/src/services/pipeline.service.ts

import api from './api';
import type { PipelineMetric } from '../interfaces/pipeline.interface';

const BASE_URL = '/pipeline';

export class PipelineService {

  /**
   * Busca o histórico do usuário.
   * O backend devolve uma linha por trace_id (a mais recente).
   * Retorna o array cru de PipelineMetric.
   */
  static async obterHistorico(userId: number): Promise<PipelineMetric[]> {
    const response = await api.get(`${BASE_URL}/historico/${userId}`);
    return response.data.data ?? [];
  }

  /**
   * Busca todas as linhas de pipeline_metrics para um trace_id.
   * Retorna o array cru. Sem agregação, sem tradução.
   */
  static async obterExecucao(
    userId: number,
    traceId: string
  ): Promise<PipelineMetric[]> {
    const response = await api.get(`${BASE_URL}/execucao/${userId}/${traceId}`);
    return response.data.data ?? [];
  }

  /**
   * Busca execuções em andamento do usuário.
   * O backend devolve uma linha por trace_id cuja última linha tem
   * status STARTED ou RUNNING.
   * Retorna o array cru.
   */
  static async obterExecucoesRodando(userId: number): Promise<PipelineMetric[]> {
    const response = await api.get(`${BASE_URL}/running/${userId}`);
    return response.data.data ?? [];
  }
}